<template>
    <div>
        <!-- <div class="mb-10">
            <intervention-tournee-list />
        </div> -->
        <!-- 🔀 SWITCH MODE -->
        <!-- <div class="flex items-center gap-4 mt-6 px-6">
            <button
                @click="switchMode('table')"
                :class="mode === 'table' ? activeTab : inactiveTab"
                class="px-4 py-2 rounded-lg"
            >
                <i class="fas fa-list mr-1"></i> Tableau
            </button>

            <button
                @click="switchMode('calendar')"
                :class="mode === 'calendar' ? activeTab : inactiveTab"
                class="px-4 py-2 rounded-lg"
            >
                <i class="fas fa-calendar-alt mr-1"></i> Calendrier
            </button>
        </div> -->

        <!-- ======================= TABLEAU ====================== -->
        <div v-show="mode === 'table'">
            <div class="flex justify-between items-center mb-4">
                <!-- <template v-if="$account.account.can_intervention">
                    <button
                        @click="$modal.show('modal-add-intervention')"
                        class="bg-red-600 text-white px-4 py-2 rounded-lg shadow"
                    >
                        <i class="fas fa-plus mr-1"></i> Nouvelle intervention
                    </button>
                </template> -->
            </div>

            <intervention-table
                @view="openViewModal"
                @plan="planifier"
            />
        </div>

        <!-- ===================== CALENDRIER ===================== -->
        <!-- <div v-show="mode === 'calendar'" class="pb-6">

            <div class="bg-white shadow-sm sticky top-20 z-10 mt-10 mx-4 rounded-lg border border-gray-200">

                <div class="flex items-center justify-between px-4 py-2 border-b">
                    <button @click="prevWeek" class="p-2 active:scale-95">
                        <i class="fas fa-chevron-left text-gray-600"></i>
                    </button>

                    <p class="text-sm font-medium text-gray-700">
                        {{ weekLabel }}
                    </p>

                    <button @click="nextWeek" class="p-2 active:scale-95">
                        <i class="fas fa-chevron-right text-gray-600"></i>
                    </button>
                </div>

                <div class="flex overflow-x-auto no-scrollbar px-2 py-2 gap-2">
                    <button
                        v-for="day in weekDays"
                        :key="day.date"
                        @click="selectDate(day.date)"
                        class="flex flex-col items-center justify-center min-w-[56px] px-3 py-2 rounded-xl text-sm transition-all"
                        :class="day.date === selectedDate
                            ? 'bg-gradient-to-r from-red-600 to-orange-500 text-white shadow'
                            : 'bg-gray-100 text-gray-700'"
                    >
                        <span class="text-xs uppercase">
                            {{ day.label }}
                        </span>
                        <span class="text-lg font-semibold">
                            {{ day.day }}
                        </span>
                        <span v-if="day.isToday" class="text-[10px] mt-0.5">
                            Aujourd’hui
                        </span>
                    </button>
                </div>

            </div>

            <template v-if="$account.account.societe.independant">
                <div class="p-4">
                    <template v-if="loadingInterventions">
                        <div class="flex justify-center items-center h-64">
                            <i class="fas fa-spinner fa-spin text-3xl text-gray-400"></i>
                        </div>
                    </template>

                    <template v-else>
                        <intervention-planning-day
                            :date="selectedDate"
                            :interventions="interventions"
                            @click-event="(data) => openViewModal(data.id)"
                        />
                    </template>
                </div>
            </template>

            <template v-else>
                <div class="p-4">
                    <intervention-calendar
                        :default-date="selectedDate"
                        @view="openViewModal"
                    />
                </div>
            </template>

        </div> -->

        <!-- ===================== MODALES ===================== -->
        <modal-intervention-view
            v-if="selectedInterventionId"
            :intervention-id="selectedInterventionId"
            @unplanned="refreshInterventions"
        />

        <modal-add-intervention />

    </div>
</template>

<script>
import ModalAddIntervention from "./Components/ModalAddIntervention.vue"
import ModalInterventionView from "./Components/ModalInterventionView.vue"
import InterventionTable from "./Components/InterventionTable.vue"
import InterventionCalendar from "./Components/InterventionCalendar.vue"
import InterventionPlanningDay from "./Components/InterventionPlanningDay.vue"

import InterventionTourneeList from "./Components/InterventionTourneeList.vue"

export default {
    name: "InterventionManager",

    components: {
        ModalAddIntervention,
        ModalInterventionView,
        InterventionTable,
        InterventionCalendar,
        InterventionPlanningDay,

        InterventionTourneeList
    },

    data() {
        const today = new Date()

        return {
            mode: "table",

            selectedDate: this.formatDateLocal(today),
            weekStart: this.getMonday(today),

            interventions: [],
            loadingInterventions: false,

            selectedInterventionId: null
        }
    },

    computed: {
        activeTab() {
            return "bg-slate-900 text-white shadow"
        },

        inactiveTab() {
            return "bg-white border shadow-sm text-gray-700"
        },

        weekDays() {
            const days = []
            const todayIso = this.formatDateLocal(new Date())

            for (let i = 0; i < 7; i++) {
                const d = new Date(this.weekStart)
                d.setDate(d.getDate() + i)

                const iso = this.formatDateLocal(d)

                days.push({
                    date: iso,
                    day: d.getDate(),
                    label: d.toLocaleDateString("fr-FR", { weekday: "short" }),
                    isToday: iso === todayIso
                })
            }

            return days
        },

        weekLabel() {
            const start = new Date(this.weekStart)
            const end = new Date(this.weekStart)
            end.setDate(end.getDate() + 6)

            return `${start.toLocaleDateString("fr-FR", { day: "numeric", month: "short" })} → ${end.toLocaleDateString("fr-FR", { day: "numeric", month: "short" })}`
        }
    },

    watch: {
        selectedDate() {
            if (this.mode === "calendar" &&
                this.$account.account.societe.independant) {
                this.loadInterventions()
            }
        }
    },

    methods: {
        switchMode(mode) {
            this.mode = mode

            if (mode === "calendar" &&
                this.$account.account.societe.independant) {
                this.loadInterventions()
            }
        },

        async loadInterventions() {
            this.loadingInterventions = true

            const response = await this.$request.post("/interventions/today", {
                date: this.selectedDate,
                only_interventions: true,
            })

            this.loadingInterventions = false

            // if (response.not_ended == 1) {
            //     this.$router.push({
            //         name: "TechInterventionView",
            //         params: { id: response.intervention.id }
            //     })
            //     return
            // }

            this.interventions = Array.isArray(response) ? response : []
        },

        getMonday(date) {
            const d = new Date(date)
            d.setHours(12, 0, 0, 0)
            const day = d.getDay() || 7
            d.setDate(d.getDate() - day + 1)
            return d
        },

        formatDateLocal(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, "0")
            const d = String(date.getDate()).padStart(2, "0")
            return `${y}-${m}-${d}`
        },

        selectDate(date) {
            this.selectedDate = date
        },

        prevWeek() {
            this.weekStart.setDate(this.weekStart.getDate() - 7)
            this.weekStart = new Date(this.weekStart)
        },

        nextWeek() {
            this.weekStart.setDate(this.weekStart.getDate() + 7)
            this.weekStart = new Date(this.weekStart)
        },

        openViewModal(id) {
            this.selectedInterventionId = id
            this.$nextTick(() => {
                this.$modal.show("modal-view-intervention-" + id)
            })
        },

        planifier(intervention) {
            this.switchMode("calendar")
            this.$nextTick(() => {
                this.$root.$emit("calendar-plan", intervention)
            })
        },
        refreshInterventions() {
            this.$eventHub.$emit('refresh-intervention-table')
        }
    },

    mounted() {
        if (this.$route.query.intervention_id) {
            this.openViewModal(this.$route.query.intervention_id)
        }
    }
}
</script>
